<template>
    <div class="LayoutBlank">
        <transition name="fade" mode="out-in">
            <router-view/>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "LayoutBlank",
        components: {},
        data() {
            return {
            }
        },
    }
</script>

<style scoped>

</style>
